import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

// Enum tanımları
export enum ProductType {
  PALET = 'PALET',
  KOLI = 'KOLI',
  KARISIK = 'KARISIK'
}

export enum RequestVehicleStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REDIRECTED = 'REDIRECTED',
  CANCELLED = 'CANCELLED',
  POSTPONED = 'POSTPONED',
  PLANNED = 'PLANNED'
}

export enum RequesterType {
  COMPANY = 'COMPANY',
  DEPO_SEFI = 'DEPO_SEFI'
}

// Label map'leri
export const productTypeLabels: Record<string, string> = {
  PALET: 'Palet',
  KOLI: 'Koli',
  KARISIK: 'Karışık'
};

export const statusLabels: Record<string, string> = {
  PENDING: 'Onay Bekliyor',
  APPROVED: 'Onaylandı',
  REDIRECTED: 'Yönlendirildi',
  CANCELLED: 'İptal Edildi',
  POSTPONED: 'Ertelendi',
  PLANNED: 'Planlandı'
};

export const statusColors: Record<string, string> = {
  PENDING: 'orange',
  APPROVED: 'green',
  REDIRECTED: 'blue',
  CANCELLED: 'red',
  POSTPONED: 'purple',
  PLANNED: 'cyan'
};

export const requesterTypeLabels: Record<string, string> = {
  COMPANY: 'Firma',
  DEPO_SEFI: 'Depo Şefi'
};

// Araç Talebi
export class VehicleRequest {
  id: string;
  desi: number;
  kg: number;
  productType: string;
  isStackable: boolean | null;
  pickupTime: string;
  isReady: boolean;
  description: string | null;
  pickupAddress: string | null;
  requesterType: string;
  status: string;
  postponedDate: string | null;
  cancelReason: string | null;
  vehiclePlanId: string | null;
  warningNotified: boolean;
  approverId: null | number;
  creatorId: number;
  companyId: number;
  createdAt: string;
  updatedAt: string;
}

// İstatistik response
export class IVehicleRequestStats {
  pending: number;
  approved: number;
  redirected: number;
  cancelled: number;
  postponed: number;
  planned: number;
}

// Paged Response
export class IVehicleRequestListResponse extends IPagination {
  @Type(() => VehicleRequest)
  results: VehicleRequest[];
  total: number;
}

// Single Response
export class IVehicleRequestResponse {
  @Type(() => VehicleRequest)
  result: VehicleRequest;
}

// Post Body DTO
export class IPostVehicleRequestBodyDto {
  desi: number;
  kg: number;
  productType: string;
  isStackable?: boolean | null;
  pickupTime: string;
  isReady: boolean;
  description?: string | null;
  pickupAddress?: string | null;
  requesterType: string;
  companyId: number;
}

// Patch Body DTO
export class IPatchVehicleRequestBodyDto {
  desi?: number;
  kg?: number;
  productType?: string;
  isStackable?: boolean | null;
  pickupTime?: string;
  isReady?: boolean;
  description?: string | null;
  pickupAddress?: string | null;
  status?: string;
  postponedDate?: string | null;
  cancelReason?: string | null;
  vehiclePlanId?: string | null;
  companyId?: number;
}

export class IVehicleRequestQueryDto extends IQueryPaginationDto {
  id?: string;
  companyId?: number;
  creatorId?: number;
  status?: string;
  requesterType?: string;
  startDate?: string;
  endDate?: string;
}

// Log Aksiyonları
export enum VehicleRequestLogAction {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  POSTPONED = 'POSTPONED',
  PLANNED = 'PLANNED',
  REDIRECTED = 'REDIRECTED',
  DELETED = 'DELETED',
  FIELD_CHANGED = 'FIELD_CHANGED'
}

export const logActionLabels: Record<string, string> = {
  CREATED: 'Oluşturuldu',
  UPDATED: 'Güncellendi',
  APPROVED: 'Onaylandı',
  CANCELLED: 'İptal Edildi',
  POSTPONED: 'Ertelendi',
  PLANNED: 'Planlandı',
  REDIRECTED: 'Yönlendirildi',
  DELETED: 'Silindi',
  FIELD_CHANGED: 'Alan Değişti'
};

export const logActionColors: Record<string, string> = {
  CREATED: 'blue',
  UPDATED: 'orange',
  APPROVED: 'green',
  CANCELLED: 'red',
  POSTPONED: 'purple',
  PLANNED: 'cyan',
  REDIRECTED: 'geekblue',
  DELETED: 'red',
  FIELD_CHANGED: 'gold'
};

// Vehicle Request Log
export class VehicleRequestLog {
  id: string;
  requestVehicleId: string;
  action: string;
  message: string;
  changes: Record<string, { old: string | number | boolean | null; new: string | number | boolean | null }> | null;
  userId: number;
  userName: string | null;
  userEmail: string | null;
  ipAddress: string | null;
  createdAt: string;
}

export class IVehicleRequestLogsResponse {
  @Type(() => VehicleRequestLog)
  results: VehicleRequestLog[];
}
